import { ErrorMessage } from "@hookform/error-message";
import { Typography } from "@material-ui/core";
import GreenhouseUserEmailSelect from "components/GreenhouseUserEmailSelect/GreenhouseUserEmailSelect";
import emailValidator from "email-validator";
import _ from "lodash";
import React from "react";
import { Control, Controller, FieldErrors } from "react-hook-form";

type FormGreenhouseUserEmailSelectProps = {
  control: Control;
  errors: FieldErrors;
  name: string;
  label?: string;
  maxEmails?: number;
  className?: string;
  defaultValues?: string[];
};

const FormGreenhouseUserEmailSelect: React.FC<
  FormGreenhouseUserEmailSelectProps
> = ({
  errors,
  defaultValues,
  control,
  name,
  maxEmails,
  className = "",
  label = "Emails",
}) => (
  <div className={className}>
    <Controller
      name={name}
      control={control}
      rules={{
        validate: (emails) =>
          _.every(emails, ({ email }) => emailValidator.validate(email)),
      }}
      defaultValue={defaultValues}
      render={({ field }) => (
        <GreenhouseUserEmailSelect
          maxEmails={maxEmails}
          label={label}
          emails={_.map(field.value, "email")}
          onChange={(values) =>
            field.onChange(_.map(values, (email) => ({ email })))
          }
          className={className}
        />
      )}
    />
    <Typography variant="subtitle1" color="error">
      <ErrorMessage
        errors={errors}
        name={name}
        message="Please enter valid email addresses"
      />
    </Typography>
  </div>
);

export default FormGreenhouseUserEmailSelect;
